import { useNavigate } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-lg font-semibold text-background-50">
              Basetao<span className="text-primary-400">Sheet</span>
            </span>
            <p className="mt-3 text-sm leading-relaxed text-background-50/50">
              The ultimate Basetao Spreadsheet resource hub. Helping shoppers discover organized finds, compare products, and shop smarter since 2026.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <button onClick={() => navigate('/basetao-spreadsheet-guide')} className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">
                  Complete Guide
                </button>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  Main Website
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  Basetao Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  Hoodies / Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200">
                  Accessories
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Quick Links</h4>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <p className="mt-4 text-xs text-background-50/40">
              &copy; 2026 BasetaoSheet. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}